import React from 'react';

import Button from '../Button';
import colours from '~/utils/colours';
import Styleable from '~/App/Components/HOC/Styleable';

export const snapButtonTheme = {
  default: {
    fg: colours.greyLightAlt2,
    bg: 'white',
    highlight: colours.blue,
  },

  active: {
    fg: colours.blue,
    bg: 'white',
    highlight: colours.blue,
  },
};

export const snapButtonStyles = {
  container: ({
    base,
    state,
    props: {
      theme,
      allProps: { round, small },
    },
  }) => ({
    ...base,

    display: 'inline-block',
    color: theme.fg,
    backgroundColor: theme.bg,
    fontSize: '1em',
    fontWeight: 'normal',
    borderRadius: round ? '20px' : '4px',
    boxShadow: '0 1px 4px rgba(0, 0, 0, 0.1)',
    border: `1px solid ${colours.borderLightGrey}`,
    padding: small ? '6px 12px' : '12px',
    margin: '7px 7px 7px 0',
    lineHeight: '100%',
    whiteSpace: 'nowrap',

    '&:hover': {
      ...base['&:hover'],
      backgroundColor: 'white',
      color: state.disabled ? null : theme.highlight,
      borderColor: state.disabled ? null : theme.highlight,
    },
  }),

  contentContainer: ({ base }) => ({
    ...base,
    fontSize: '1.1em',
  }),

  beforeIconContainer: ({ base, state, props: { theme } }) => ({
    ...base,
    color: state.hovered && !state.disabled ? theme.highlight : theme.fg,
    backgroundColor: 'white',
  }),
};

const SnapButton = (props) => <Button theme={snapButtonTheme} {...props} />;

export default Styleable(snapButtonStyles)(SnapButton);
